import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import CenterModal from "../Components/CenterSelectorModal";
import PartyReport from "../FinanceReportComponent/PartyReport";
import ProductCategory from "../FinanceReportComponent/ProductCategory";
import Reversel from "../FinanceReportComponent/Reversel";
import PaymentCollection from "../FinanceReportComponent/PaymentCollection";
import DiscoountReport from "../FinanceReportComponent/DiscountReport";

const FinanceReport = () => {

    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];
    const [selectedCenter, setSelectedCenter] = useState([]);
    const [activeTab, setActiveTab] = useState("party");
    const [radioFilter, setRadioFilter] = useState("");

    const [loading, setLoading] = useState(false);
    const [resetTrigger, setResetTrigger] = useState(0);
    const [applyTrigger, setApplyTrigger] = useState(0);
    const [dateTrigger, setDateTrigger] = useState(0);

    const [filters, setFilters] = useState({
        // startDate: "",
        // endDate: "",
        startDate: formattedToday,
        endDate: formattedToday,
        limit: "10",
        centers: []
    });
    const partyRef = useRef();
    const reverselRef = useRef();
    const nonPartyRef = useRef();
    const discountRef = useRef();

    const [show, setShow] = useState(false);
    const tabs = [
        { id: "party", label: "Party Report (GST)", icon: "mdi mdi-account-group" },
        { id: "non-party", label: "Non-Party Report (GST)", icon: "mdi mdi-file-percent" },
        // { id: "payment", label: "Payment Collection Report", icon: "mdi mdi-currency-rupee" },
        { id: "Discount-Report", label: "Discount Report", icon: "mdi mdi-sale" },
        { id: "Reversel-Report", label: "Reversel Report", icon: "mdi mdi-sale" }
    ];


    const handleRadioFilterChange = (filterType) => {
        setRadioFilter(filterType);
        // console.log('filterType', filterType);
    };

    const handleTabChange = (tabId) => {

        setActiveTab(tabId);
        handleClearFilter();
        setShow(false);
        setRadioFilter("");
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;

        if (name === "startDate") {
            const newEndDate = moment(value).add(90, "days");

            const finalEndDate = newEndDate.isAfter(moment())
                ? moment().format("YYYY-MM-DD")
                : newEndDate.format("YYYY-MM-DD");

            setFilters((prev) => ({
                ...prev,
                startDate: value,
                endDate: finalEndDate   // 👈 auto reset here
            }));
        } else {
            setFilters((prev) => ({
                ...prev,
                [name]: value
            }));
        }
        if (
            (name === "startDate" || name === "endDate") &&
            (activeTab === "party" || activeTab === "non-party")
        ) {
            setDateTrigger((prev) => prev + 1);
        }
    };

    const handleApplyFilter = () => {
        setApplyTrigger((prev) => prev + 1);
    };
    const handleClearFilter = () => {
        setFilters({
            startDate: formattedToday,
            endDate: formattedToday,
            limit: "10",
            centers: []
        });
        setSelectedCenter([]);
        setResetTrigger((p) => p + 1);
        // setResetTrigger((p) => p + 1);
    };
    useEffect(() => {
        if (applyTrigger === 0) return;
    }, [applyTrigger]);

    useEffect(() => {
    }, [radioFilter, dateTrigger]);

    const handleCSV = () => {
        if (activeTab === "party") {
            partyRef.current?.downloadCSV();
        }
        else if (activeTab === "Reversel-Report") {
            reverselRef.current?.downloadCSV();
        }
        else if (activeTab === "non-party") {
            nonPartyRef.current?.downloadCSV();
        }
        else if (activeTab === "Discount-Report") {
            discountRef.current?.downloadCSV();
        }
    };


    return (
        <div>
            <div className="modern-nav-tabs">
                {tabs.map((tab) => (
                    <div
                        key={tab.id}
                        className={`modern-tab ${activeTab === tab.id ? "active" : ""}`}
                        onClick={() => handleTabChange(tab.id)}
                        style={{ marginRight: "3px" }}
                    >
                        <i className={tab.icon}></i>
                        {tab.label}
                    </div>
                ))}
            </div>

            {activeTab === "non-party" && (
                <div className="radio-filter-section mt-3">
                    <div className="radio-filter-title">Filter By:</div>

                    <div className="radio-filter-options">
                        <div
                            className={`radio-option ${radioFilter === "productCategory" ? "selected" : ""}`}
                            onClick={() => handleRadioFilterChange("productCategory")}
                        >
                            <input type="radio" checked={radioFilter === "productCategory"} readOnly />
                            <label>Product Category</label>
                        </div>

                        <div
                            className={`radio-option ${radioFilter === "product" ? "selected" : ""}`}
                            onClick={() => handleRadioFilterChange("product")}
                        >
                            <input type="radio" checked={radioFilter === "product"} readOnly />
                            <label>Product</label>
                        </div>
                    </div>
                </div>
            )}

            {activeTab === "Discount-Report" && (
                <div className="radio-filter-section mt-3">
                    <div className="radio-filter-title">Filter By:</div>

                    <div className="radio-filter-options">
                        <div
                            className={`radio-option ${radioFilter === "adhock" ? "selected" : ""}`}
                            onClick={() => handleRadioFilterChange("adhock")}
                        >
                            <input type="radio" checked={radioFilter === "adhock"} readOnly />
                            <label>Ad-Hock</label>
                        </div>

                        <div
                            className={`radio-option ${radioFilter === "coupon" ? "selected" : ""}`}
                            onClick={() => handleRadioFilterChange("coupon")}
                        >
                            <input type="radio" checked={radioFilter === "coupon"} readOnly />
                            <label>Coupon</label>
                        </div>
                    </div>
                </div>
            )}

            {activeTab === "Discount-Report" && radioFilter === "" && (
                <div className="alert alert-danger">
                    Please select Ad-Hock or Coupon to view the report.
                </div>
            )}
            {activeTab === "non-party" && radioFilter === "" && (
                <div className="alert alert-danger">
                    Please select Product Category or Product to view the report.
                </div>
            )}

            <div className="modern-filter-section mt-3">
                <div className="filter-title">
                    <i className="mdi mdi-filter-variant-plus"></i>
                    <span>Filter Options</span>
                </div>

                <div className="row g-3">
                    <div className="col-md-4">

                        <CenterModal
                            key={resetTrigger}
                            onSelectCenter={setSelectedCenter}
                            resetTrigger={resetTrigger}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="filter-label">Start Date</label>
                        <input
                            type="date"
                            className="form-control"
                            name="startDate"
                            value={filters.startDate || ""}
                            onChange={handleFilterChange}
                            //  min={formattedPastDate}
                            max={formattedToday}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="filter-label">End Date</label>

                        <input
                            type="date"
                            className="form-control"
                            name="endDate"
                            value={filters.endDate || ""}
                            onChange={handleFilterChange}
                            min={filters.startDate}
                            max={
                                filters.startDate
                                    ? moment.min(
                                        moment(filters.startDate).add(90, "days"),
                                        moment()
                                    ).format("YYYY-MM-DD")
                                    : formattedToday
                            }
                        />
                    </div>
                </div>
                <div className="filter-actions d-flex align-items-center gap-2">
                    <button
                        className="btn-modern btn-modern-primary"
                        onClick={handleApplyFilter}
                        disabled={loading}
                    >
                        <i className="mdi mdi-check"></i>
                        {loading ? "Applying..." : "Apply Filter"}
                    </button>

                    <button
                        className="btn-modern btn-modern-outline"
                        onClick={handleClearFilter}
                    >
                        <i className="mdi mdi-close"></i> Clear Filter
                    </button>

                    {activeTab !== "payment" && radioFilter !== "coupon" && (

                        <button
                            className="btn-modern btn-modern-outline"
                            style={{
                                backgroundColor: "#1D6F42",
                                color: "#fff",
                                border: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "8px 14px",
                                borderRadius: "6px",
                                fontWeight: "500",
                                marginLeft: "auto",
                            }}
                            onClick={handleCSV}
                        >
                            <i className="mdi mdi-google-spreadsheet"></i> Export to Excel
                        </button>


                    )}

                </div>

            </div>

            <div className="mt-4">
                {activeTab === "party" && (

                    <PartyReport
                        ref={partyRef}
                        filters={filters}
                        selectedCenter={selectedCenter}
                        resetTrigger={resetTrigger}
                        applyTrigger={applyTrigger}
                        dateTrigger={dateTrigger}
                    />

                )}

                {activeTab === "non-party" && radioFilter === "productCategory" && (
                    <ProductCategory
                        filters={filters}
                        selectedCenter={selectedCenter}
                        resetTrigger={resetTrigger}
                        applyTrigger={applyTrigger}
                        dateTrigger={dateTrigger}
                        radioFilter={radioFilter}
                        ref={nonPartyRef}
                    />
                )}

                {activeTab === "non-party" && radioFilter === "product" && (
                    <ProductCategory
                        filters={filters}
                        selectedCenter={selectedCenter}
                        resetTrigger={resetTrigger}
                        applyTrigger={applyTrigger}
                        dateTrigger={dateTrigger}
                        radioFilter={radioFilter}
                        ref={nonPartyRef}
                    />
                )}
                {activeTab === "payment" && (
                    <PaymentCollection
                        filters={filters}
                        selectedCenter={selectedCenter}
                        resetTrigger={resetTrigger}
                        applyTrigger={applyTrigger}
                        dateTrigger={dateTrigger}
                    />
                )}

                {activeTab === "Discount-Report" && radioFilter === "adhock" && (
                    <DiscoountReport
                        filters={filters}
                        selectedCenter={selectedCenter}
                        resetTrigger={resetTrigger}
                        applyTrigger={applyTrigger}
                        dateTrigger={dateTrigger}
                        radioFilter={radioFilter}
                        ref={discountRef}
                    />
                )}
                {activeTab === "Discount-Report" && radioFilter === "coupon" && (

                    <DiscoountReport
                        filters={filters}
                        selectedCenter={selectedCenter}
                        resetTrigger={resetTrigger}
                        applyTrigger={applyTrigger}
                        dateTrigger={dateTrigger}
                        radioFilter={radioFilter}
                        ref={discountRef}
                    />
                )}


                {activeTab === "Reversel-Report" && (
                    <Reversel
                        filters={filters}
                        selectedCenter={selectedCenter}
                        resetTrigger={resetTrigger}
                        applyTrigger={applyTrigger}
                        dateTrigger={dateTrigger}
                        ref={reverselRef}
                    />
                )}

            </div>

            <ToastContainer />
        </div>
    );
};

export default FinanceReport;

